import { addDays } from 'date-fns/addDays';
import { isToday } from 'date-fns/isToday';
import { startOfDay } from 'date-fns/startOfDay';
import { startOfToday } from 'date-fns/startOfToday';
import { useState } from 'react';

import { friendlyFormatDate } from '@/utils/formats';

import { useSummaryTimelineQuery } from './summary-timeline.query';

export function useSummaryDay() {
  const [day, setDay] = useState(startOfToday);
  const query = useSummaryTimelineQuery(day);

  return {
    day,
    label: friendlyFormatDate(day),
    isToday: isToday(day),
    items: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error,
    pick: (next: Date) => setDay(startOfDay(next)),
    goPrev: () => setDay(addDays(day, -1)),
    goNext: () => setDay(addDays(day, 1)),
    goToday: () => setDay(startOfToday()),
  };
}
